// format of category urn is `urn:category:{{ slug }}`
// https://github.com/leland-dev/leland-backend/blob/main/src/main/java/com/leland/urn/CategoryUrn.java
const CATEGORY_URN_PREFIX = 'urn:category:';
export const categorySlugToUrn = (slug: string) =>
  `${CATEGORY_URN_PREFIX}${slug}`;

export const categoryUrnToSlug = (urn: string) =>
  urn.replace(CATEGORY_URN_PREFIX, '');
